import api from './api';
import {
  Organization,
  OrganizationListResponse,
  OrganizationMember,
} from '../types/organization';

export const organizationService = {
  async list(): Promise<Organization[]> {
    const response = await api.get<OrganizationListResponse>('/organizations');
    return response.data.data;
  },

  async create(data: {
    name: string;
    slug: string;
    description?: string;
  }): Promise<Organization> {
    const response = await api.post<Organization>('/organizations', data);
    return response.data;
  },

  async members(orgId: string): Promise<OrganizationMember[]> {
    const response = await api.get<OrganizationMember[]>(
      `/organizations/${orgId}/members`
    );
    return response.data;
  },

  async addMember(
    orgId: string,
    email: string,
    role: string
  ): Promise<OrganizationMember> {
    const response = await api.post<OrganizationMember>(
      `/organizations/${orgId}/members`,
      { email, role }
    );
    return response.data;
  },

  async removeMember(orgId: string, userId: string): Promise<void> {
    await api.delete(`/organizations/${orgId}/members/${userId}`);
  },
};
